<template>
  <div class="range-selector">
    <div class="range-selector__btn" :class="{ active: showOption === 'week' }" @click="changeView('week')">Denne uge</div>
    <div class="range-selector__btn" :class="{ active: showOption === 'month' }" @click="changeView('month')">Denne måned</div>
    <div class="range-selector__btn" :class="{ active: showOption === 'special' }" @click="changeView('special')">Tilpasset</div>
    <v-dialog
      v-model="dialog"
      width="500"
      overlay-color="#ffffff"
      overlay-opacity="0.9"
    >
      <v-card>
        <v-date-picker
          v-model="pickedRange"
          first-day-of-week="1"
          locale="da-DK"
          range
          full-width
          class="elevation-0"
        ></v-date-picker>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="cancelRange"
          >
            Annuller
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="setRange"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';

export default {
  data() {
    return {
      dialog: false,
      showOption: 'week',
      dateRange: {
        start: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        end: moment().endOf('isoWeek').format('YYYY-MM-DD')
      },
      prevRange: {},
      prevShowOption: '',
      pickedRange: []
    }
  },
  methods: {
    changeView(option) {  
      this.showOption = option;
      if (this.showOption === 'week') {
        this.dateRange.start = moment().startOf('isoWeek').format('YYYY-MM-DD');
        this.dateRange.end = moment().endOf('isoWeek').format('YYYY-MM-DD');
        localStorage.setItem('showOption', 'week');
        localStorage.setItem('range', JSON.stringify(this.dateRange));
      } else if (this.showOption === 'month') {
        this.dateRange.start = moment().startOf('month').format('YYYY-MM-DD');
        this.dateRange.end = moment().endOf('month').format('YYYY-MM-DD');
        localStorage.setItem('showOption', 'month');
        localStorage.setItem('range', JSON.stringify(this.dateRange));
      } else {
        this.prevRange = _.clone(this.dateRange);
        this.prevShowOption = localStorage.getItem('showOption');
        this.dialog = true;
      }
      this.$parent.$emit('new-range', this.dateRange);
    },
    setRange() {
      this.showOption = 'special'
      this.dateRange.start = this.pickedRange[0];
      this.dateRange.end = this.pickedRange[1];
      localStorage.setItem('showOption', 'special');
      localStorage.setItem('range', JSON.stringify(this.dateRange));
      this.$parent.$emit('new-range');
      this.pickedRange = [];
      this.dialog = false;
    },
    cancelRange() {
      this.dialog = false;
      this.showOption = this.prevShowOption;
      this.dateRange = this.prevRange;
      this.prevRange = {};
      localStorage.setItem('range', JSON.stringify(this.dateRange));
      this.$parent.$emit('new-range');
    }
  },
  created() {
    if(localStorage.getItem('showOption') !== null) {
      this.showOption = localStorage.getItem('showOption');
    }
  }
}
</script>

<style lang="scss">
  .range-selector {
    width: 100%;
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    &__btn {
      flex: 1;
      height: 40px;
      border: 1px solid rgba(#fff, 0.7);
      line-height: 40px;
      text-align: center;
      font-weight: 500;
      cursor: pointer;

      &.active {
        background-color: rgba(#fff, 0.7);
        color: #151D31;
      }
    }

    .v-card {
      .v-picker.v-card,
      .v-card {
        box-shadow: 0 !important;
      }
    }
  }
</style>